var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.centered ? 'mx-auto' : '',style:(_vm.wrapperStyle)},[_c('div',{style:(_vm.lineStyle)})])
}
var staticRenderFns = []

export { render, staticRenderFns }